import { type FC } from 'react';
import { LocalQueryRenderer, type Environment } from 'react-relay/legacy';
import { PhotosSearchBrowseQuery } from './PhotosSearchBrowseQuery';
import { PhotosSearchBrowseWrapper } from './PhotosSearchBrowseWrapper';

import { type PhotosSearchBrowseQuery as QueryType } from './__generated__/PhotosSearchBrowseQuery.graphql';
import { type RelayVariables } from './types';

type PhotosSearchBrowseContainerProps = {
    environment: Environment;
    relayVariables: RelayVariables;
};

export const PhotosSearchBrowseContainer: FC<PhotosSearchBrowseContainerProps> = ({
    environment,
    relayVariables,
}) => (
    <LocalQueryRenderer<QueryType>
        environment={environment}
        query={PhotosSearchBrowseQuery}
        variables={relayVariables}
        render={({ props, error }) => {
            if (error) {
                // eslint-disable-next-line no-console
                console.error('error!', error);
                return null;
            }

            return (
                <PhotosSearchBrowseWrapper
                    relayVariables={relayVariables}
                    viewer={props?.viewer || null}
                    originalUrl={window.location.pathname + window.location.search}
                />
            );
        }}
    />
);
